import { OrderByDirection, type Backend } from '@freelancer/datastore/core';
import type { OnboardingEmailChangeCollection } from './onboarding-email-change.types';

export function onboardingEmailChangeBackend(): Backend<OnboardingEmailChangeCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    },
    fetch: () => {
      return {
        endpoint: 'user/onboarding-email-change-eligible.php',
        method: 'GET',
        isGaf: true,
      };
    },
    push: (_, document) => {
      return {
        endpoint: 'user/onboarding-email-change.php',
        method: 'POST',
        isGaf: true,
        payload: {
          email: document.email,
          ...(document.deviceToken
            ? { device_token: document.deviceToken }
            : {}),
        },
      };
    },
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
